import { EventBoolean } from '../../../webmodule-common/other/ui/events';
import { getApiFactory } from '../../api/api-injector';
import { ProjectContainer, ProjectContainerManager } from '../../projects/data/project-container';

export function getProjectContainer(id: string): ProjectContainer {
  return new ProjectContainer(id, null, null, null);
}

export function getProjectContainerManager(
  id: string | ProjectContainer,
  forceLocked?: EventBoolean
): ProjectContainerManager {
  const container = id instanceof ProjectContainer ? id : getProjectContainer(id);

  const manager = new ProjectContainerManager(container, getApiFactory().project());
  manager.forceLocked = forceLocked;
  return manager;
}
